import { Box, Text, Icon, Flex, HStack, Avatar } from 'src/components/ui';
import { RiMore2Line } from 'react-icons/ri';
import { IChannelCreativeAttributes } from 'src/lib/schemas';
import { CampaignContext } from 'src/contexts/campaign';
import { useContext, useEffect, useState } from 'react';
import UserContext from 'src/contexts/user/UserContext';
import CreativeCard from './CreativeCard';
import { ICreative } from 'src/lib/schemas/campaign/newFlowCampaign';

interface GoogleCreativeProps {
	creative: ICreative;
	withActions?: boolean;
	selectedHeadline?: string;
	selectedDescription?: string;
	creativesConfig?: IChannelCreativeAttributes[];
}

const GoogleCreative = ({
	creative,
	withActions = true,
	selectedHeadline,
	selectedDescription,
	creativesConfig,
}: GoogleCreativeProps) => {
	const { campaign } = useContext(CampaignContext);
	const { account } = useContext(UserContext);
	const destination = campaign?.destination ?? '';
	const { headlines, descriptions } = (creative as any).attributes;
	const headline = selectedHeadline ?? headlines?.[0];
	const description = selectedDescription ?? descriptions?.[0];
	const [logo, setLogo] = useState<string | undefined>(account?.logoSquare);

	useEffect(() => {
		setLogo(account?.logoSquare);
	}, [account]);

	return (
		<CreativeCard
			creative={creative}
			withActions={withActions}
			creativesConfig={creativesConfig}
			size="lg"
			title="Google"
		>
			<Box
				border="1px"
				borderRadius="md"
				borderColor="gray.200"
				bg="white"
				maxW="lg"
				p={4}
				boxShadow="md"
			>
				<Text fontSize="sm" fontWeight="bold" mb={2}>
					Sponsored
				</Text>

				<Flex justifyContent="space-between" alignItems="center">
					<HStack spacing={3} maxW="lg">
						<Avatar
							key={logo || 'no-logo'}
							src={logo}
							sx={{
								img: {
									objectFit: 'contain',
								},
							}}
						/>
						<Box maxW="sm">
							<Text fontWeight={500}>{account?.name}</Text>
							<Text
								color="gray.500"
								whiteSpace="nowrap"
								overflow="hidden"
								textOverflow="ellipsis"
								fontSize="sm"
							>
								{destination}
							</Text>
						</Box>
					</HStack>
					<Icon as={RiMore2Line} boxSize={5} color="gray.500" />
				</Flex>
				<Text
					data-testid="google-content"
					mt={3}
					fontSize="lg"
					color="blue.600"
				>
					{headline}
				</Text>
				<Text mt={2} fontSize="sm" color="gray.700">
					{description}
				</Text>
			</Box>
		</CreativeCard>
	);
};

export default GoogleCreative;
